/* eslint-disable new-cap */
/* eslint-disable lines-between-class-members */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';

import Plyr from 'plyr';

import './styles.css';

class PlyrPlayer extends React.Component {
  player = null;
  elementRef = new React.createRef();

  componentDidMount() {
    const node = this.elementRef.current;
    this.player = new Plyr(node, this.props.options);
    this.player.source = this.props.source;

    if (this.props.trackSession) {
      this.subscribeToEvents();
    }
  }

  componentWillUnmount() {
    this.player.destroy();
  }

  subscribeToEvents() {
    if (this.props.onPlay) {
      this.player.on('playing', () => {
        this.props.onPlay({
          duration: this.player.duration,
          currentTime: this.player.currentTime,
        });
      });
    }

    if (this.props.onTimeUpdate) {
      this.player.on('timeupdate', () => {
        this.props.onTimeUpdate({
          duration: this.player.duration,
          currentTime: this.player.currentTime,
        });
      });
    }

    if (this.props.onSeeked) {
      this.player.on('seeked', () => {
        this.props.onSeeked({
          duration: this.player.duration,
          currentTime: this.player.currentTime,
        });
      });
    }

    if (this.props.onEnded) {
      this.player.on('ended', () => {
        this.props.onEnded({
          duration: this.player.duration,
          currentTime: this.player.currentTime,
        });
      });
    }
  }

  render() {
    return (
      <div>
        <video ref={this.elementRef}></video>
      </div>
    );
  }
}

PlyrPlayer.defaultProps = {
  options: {
    controls: [],
    i18n: {},
  },
  sources: {
    type: 'video',
    sources: [],
  },
};

PlyrPlayer.propTypes = {
  options: PropTypes.object.isRequired,
  source: PropTypes.object.isRequired,

  trackSession: PropTypes.bool,

  onPlay: PropTypes.func,
  onTimeUpdate: PropTypes.func,
  onSeeked: PropTypes.func,
  onEnded: PropTypes.func,
};

PlyrPlayer.defaultProps = {
  trackSession: false,

  onPlay() {},
  onTimeUpdate() {},
  onSeeked() {},
  onEnded() {},
};

export default PlyrPlayer;
